/* eslint-disable react/no-danger-with-children */

import React from 'react';

export const CheckBoxK = ({ text, color, checked }) => {
  return (
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <div className="custom-checkbox">
        <input
          type="checkbox"
          style={{ borderColor: color, width: '20px', height: '20px', cursor: 'pointer' }}
          checked={checked}  // Set the checked prop
          // onChange={handleChange}
        />
      </div>
      <div style={{color:'#131F32',marginLeft:'5px'}} dangerouslySetInnerHTML={{ __html: text }} />
    </div>
  );
};

export default CheckBoxK;

